// Added by Sejune Oh on 2019-03-11
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Theme } from '@material-ui/core'
import { Property } from 'csstype'
import { MGMT_FORM_MIN_WIDTH, MGMT_FORM_MAX_WIDTH, LIGHT_GREY } from '../Theme'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const styles = (theme: Theme) => ({
  EditFormPaper: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column' as Property.FlexDirection,
    alignSelf: 'center' as Property.AlignSelf,
    // width: '50%',
    // minWidth: '600px',
    minWidth: `${MGMT_FORM_MIN_WIDTH}px`,
    maxWidth: `${MGMT_FORM_MAX_WIDTH}px`,
    width: '100%',
    // minHeight: '680px',
    position: 'relative' as Property.Position,
    /* Aview Common Style */
    borderRadius: 0,
    boxShadow: 'none',
    border: '1px solid #000',
  },
  NotFoundWrapper: {
    padding: `${theme.spacing() * 4}px ${theme.spacing() * 2}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column' as Property.FlexDirection,
    color: LIGHT_GREY,
  },
  NotFoundIcon: {
    width: '3rem',
    height: '3rem',
    marginBottom: `${theme.spacing()}px`,
  },
  NotFoundTitle: {
    color: LIGHT_GREY,
  },
  ErrNotiWrapper: {
    position: 'fixed' as Property.Position,
    transform: 'translateX(0)' as Property.Transform,
    right: `${theme.spacing()}px`,
    bottom: `${theme.spacing()}px`,
    justifyContent: 'flex-end' as Property.JustifyContent,
  },
  ErrNoti: {
    backgroundColor: theme.palette.error.main as Property.BackgroundColor,
    color: theme.palette.error.contrastText as Property.Color,
  },
  InfoNoti: {
    backgroundColor: theme.palette.primary.main as Property.BackgroundColor,
    color: theme.palette.error.contrastText as Property.Color,
  },
})

export default styles
